let data15;
if (typeof window === "undefined") {
  data15 = require("../static-s15/Data.json");
} else {
  // data15 = require("../static-s15/Data.json");
  // window.data15 = data15;
  data15 = window.data15;
}

export { data15 };
